let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("6xyLF")).then(() => parcelRequire('g1Eu7'));